import React from 'react';

import NeoLoader from './components/neoLoader';

export default function Loader() {
	return (
		<div className="loader">
			<NeoLoader/>
		</div>
	);
}
